import API from '../../../../../services/api';

export const API_DESGUACES = {
  fetchInfoDesguace: async (desguaceId,) => {
    return await API.get('/desguaces/info/' + desguaceId).then(res => res.data);
  }
}
